import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'

import CheckboxWithLabel from 'components/CheckboxWithLabel'

const CheckboxGroup = ({
  items,
  selectedItems,
  handleChange,
  header,
  isRequired,
  menuFilterQuery,
}) => {
  return (
    <section className="checkbox-group">
      <header>
        <p className="checkbox-group__header">{header}</p>
      </header>
      {map(items, (item, index) => {
        const menus = item.menus.filter(menu => menu.serviceType === menuFilterQuery)
        return (
          <div className="checkbox-group__subgroup" key={index}>
            <header>
              <p className="checkbox-group__subheader">{item.name}</p>
            </header>
            {menus.map(menu => (
              <CheckboxWithLabel
                checked={selectedItems.includes(menu.uuid)}
                className="checkbox-group__item"
                key={menu.uuid}
                label={menu.name || 'Unamed menu'}
                name={menu.uuid}
                onChange={handleChange}
                required={isRequired}
              />
            ))}
          </div>
        )
      })}
    </section>
  )
}

CheckboxGroup.defaultProps = {
  items: [],
  selectedItems: [],
  handleChange: () => {},
  header: '',
  menuFilterQuery: '',
  isRequired: PropTypes.bool,
}

CheckboxGroup.propTypes = {
  items: PropTypes.array.isRequired,
  selectedItems: PropTypes.array,
  handleChange: PropTypes.func.isRequired,
  header: PropTypes.string,
  menuFilterQuery: PropTypes.string,
  isRequired: PropTypes.bool,
}

export default CheckboxGroup
